// removed by extract-text-webpack-plugin
module.exports = {"menu":"jXRiL6P60VjZOq6Uigj9G","header":"_1raK9rd86zNwarUruhbvBb","title":"_3Ac4e0ll-5Lm_ybBe5rmQf","nav":"qQQNH7bzlCo9wIU2KkmsY","item":"_3dpogvxF4WHew_sVRhOEEF","activeItem":"_3oRHLRggHoExsy5kJLWZiF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MainNavigation/MainNavigation.scss
// module id = 918
// module chunks = 0